/* Cliente único para GeoServer: URLs, capas, escape CQL y errores legibles */

export const WFS_BASE = process.env.REACT_APP_WFS_BASE || 'https://geoserver.municipioderawson.gob.ar/geoserver/Muni_Rawson/ows';
export const WMS_BASE = process.env.REACT_APP_WMS_BASE || 'https://geoserver.municipioderawson.gob.ar/geoserver/Muni_Rawson/wms';

export const LAYERS = {
    parcelas: 'Muni_Rawson:parcelas_2025',
    comercios: 'Muni_Rawson:Comercios',
    limites: 'Muni_Rawson:Limites',
};

/* Error con mensaje apto para mostrar al usuario */
export class WfsError extends Error {
    constructor(message, cause) {
        super(message);
        this.name = 'WfsError';
        this.cause = cause;
    }
}

export const isAbortError = (err) => !!err && err.name === 'AbortError';

/* Texto para mostrar al usuario ante cualquier error */
export const userMessage = (err) => (err instanceof WfsError ? err.message : 'Ocurrió un error inesperado. Intentá de nuevo.');

/* Literal de texto CQL/ECQL: la comilla simple se escapa duplicándola */
export function cqlString(value) {
    return `'${String(value).replace(/'/g, "''")}'`;
}

/* bbox: [minX, minY, maxX, maxY] en EPSG:4326 */
export function buildGetFeatureUrl(typeName, { cql, bbox, maxFeatures, propertyNames } = {}) {
    const params = new URLSearchParams({
        service: 'WFS',
        version: '1.1.0',
        request: 'GetFeature',
        typeName,
        outputFormat: 'application/json',
    });
    // GeoServer no admite CQL_FILTER y bbox juntos
    if (cql) params.set('CQL_FILTER', cql);
    else if (bbox) params.set('bbox', `${bbox.join(',')},EPSG:4326`);
    if (propertyNames) params.set('propertyName', propertyNames.join(','));
    if (maxFeatures) params.set('maxfeatures', String(maxFeatures));
    return `${WFS_BASE}?${params.toString()}`;
}

/* Devuelve el array de features. Lanza WfsError (o AbortError si se canceló) */
export async function getFeatures(typeName, options = {}) {
    const url = buildGetFeatureUrl(typeName, options);
    let res;
    try {
        res = await fetch(url, { signal: options.signal });
    } catch (err) {
        if (isAbortError(err)) throw err;
        throw new WfsError('No se pudo conectar con el servidor de mapas. Revisá tu conexión e intentá de nuevo.', err);
    }

    const text = await res.text();
    if (!res.ok) {
        throw new WfsError(`El servidor de mapas respondió con un error (${res.status}). Intentá de nuevo más tarde.`);
    }
    try {
        // Si el filtro es inválido GeoServer responde 200 con XML de excepción
        return JSON.parse(text).features || [];
    } catch (err) {
        throw new WfsError('El servidor de mapas devolvió una respuesta inválida.', err);
    }
}
